import PropTypes from 'prop-types';
import { List } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { WidgetPreviewContainer } from 'decap-cms-ui-default';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
function ListPreview({
  values
}) {
  return _jsx("ul", {
    children: values.map((value, idx) => _jsx("li", {
      children: value
    }, idx))
  });
}
function SelectPreview({
  value
}) {
  return _jsxs(WidgetPreviewContainer, {
    children: [value && (List.isList(value) ? _jsx(ListPreview, {
      values: value
    }) : value), !value && null]
  });
}
SelectPreview.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, ImmutablePropTypes.list])
};
export default SelectPreview;